import * as React from 'react'
import PropTypes from 'prop-types'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Box from '@mui/material/Box'
import { useMediaQuery } from '@mui/material'

import LinksTab from './links/LinksTab'
import ProfileTab from './settings/ProfileTab'
import StylingTab from './styling/StylingTab'
import AnalyticsTab from './analytics/AnalyticsTab'


function CustomTabPanel({ children, value, index, ...other }) {
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
            style={{ width: '100%', minWidth: 0 }}
        >
            {value === index && <Box sx={{ p: { xs: 1, sm: 2, md: 3 } }}>{children}</Box>}
        </div>
    )
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    }
}

export default function TabSection({ user, page }) {
    const [value, setValue] = React.useState(0)
    const isMobile = useMediaQuery('(max-width:1050px)')

    const handleChange = (_, newValue) => setValue(newValue)

    return (
        // Single source of truth for the studio column width: a definite-width wrapper holds both
        // the tab strip and every panel, so all tabs render at the exact same width. minWidth:0 +
        // overflowX:hidden guarantee no tab's content (e.g. long link titles) can stretch it.
        <Box sx={{ width: isMobile ? '100%' : '42vw', maxWidth: '100%', minWidth: 0, overflowX: 'hidden' }}>
            <Box sx={{
                display: 'block',
                borderBottom: 1,
                borderColor: 'divider',
                width: '100%',
            }}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    variant='fullWidth'
                    aria-label="vibio tabs section"
                >
                    <Tab sx={{ textTransform: 'none' }} label="Links" {...a11yProps(0)} />
                    <Tab sx={{ textTransform: 'none' }} label="Customize" {...a11yProps(1)} />
                    <Tab sx={{ textTransform: 'none' }} label="Analytics" {...a11yProps(2)} />
                    <Tab sx={{ textTransform: 'none' }} label="Profile" {...a11yProps(3)} />
                </Tabs>
            </Box>

            <CustomTabPanel value={value} index={0}>
                <LinksTab user={user} />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
                <StylingTab user={user} />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={2}>
                <AnalyticsTab user={user} page={page} />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={3}>
                <ProfileTab user={user} />
            </CustomTabPanel>
        </Box>
    )
}
